/*------------------------------------------------------------------
Please read!
------------------------------------------------------------------*/

/*
This file is a symlink to the blocks.js file in the app folder,
making changes here affects subsites that are using the blocks.js
*/

/*------------------------------------------------------------------
Import the block scripts
------------------------------------------------------------------*/

// document.addEventListener('DOMContentLoaded', () => {
// I have commented the load event listener out because this script is now deferred

// Add the src and a condition required to load the script
window.BlocksLoader = ScriptLoader({
  // './blocks/default/code': document.querySelector('.js-default-code'),
  './blocks/default/accordion': document.querySelector('.js-default-accordion'),
  './blocks/default/tabs': document.querySelector('.js-default-tabbed-content'),
  './blocks/default/slider': document.querySelector('.js-default-slider'),
  './blocks/default/gallery': document.querySelector('.js-default-gallery'),
  './blocks/default/highlights': document.querySelector('.js-default-highlights'),
  './blocks/default/partners': document.querySelector('.js-default-partners'),
  './blocks/default/team': document.querySelector('.js-default-team'),
  './blocks/default/blog': document.querySelector('.js-default-blog'),
  './blocks/default/map': document.querySelector('.js-default-map'),
  './blocks/default/customer-highlights': document.querySelector('.js-default-customer-highlights'),
  './blocks/default/decision-tree': document.querySelector('.js-default-decision-tree'),
  './blocks/default/eligibility': document.querySelector('.js-default-eligibility'),
  './blocks/default/countdown': document.querySelector('countdown-timer'),
  './blocks/default/podcast': document.querySelector('.js-default-podcast'),
  './blocks/zoom/image': document.querySelector('.js-zoom-image'),
  './blocks/gallery/testimonial': document.querySelector('.js-gallery-testimonial'),
  './blocks/gallery/blog': document.querySelector('.js-gallery-blog'),
  './blocks/gallery/link': document.querySelector('.js-gallery-link'),
  './blocks/popup/eligibility': document.querySelector('.js-popup-eligibility')
}, 'blocks-loaded');

/*------------------------------------------------------------------
Script Loader
------------------------------------------------------------------*/

function ScriptLoader() {
  let imports = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let evt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'scripts-loaded';
  // An array of the import object keys
  const scripts = Object.keys(imports).filter(key => imports[key]);
  // For debugging purposes only
  const components = [];
  Promise.all(scripts.map(script => import(`${script}`).then(() => components.push(script)).catch(error => console.warn(error)))).then(() => setTimeout(() => window.dispatchEvent(new Event(evt)), 500));
  return components;
}
window.addEventListener('blocks-loaded', () => {
  console.log("%cblocks", "color:#0c0c0d; font-family: monospace; font-size: 20px; padding: 5px 10px; border-radius: 5px; background-color: #bbb");
  document.body.classList.add('blocks-loaded');
});